import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { deactivateRcsTemplatesMutation } from "api/Enterprise/Template/Rcs/deactivateRcsTemplate";
import { downloadRegisteredRcsTemplatesMutation } from "api/Enterprise/Template/Rcs/downloadRegisteredRcsTemplates";
import { getRegisteredRcsTemplatesMutation } from "api/Enterprise/Template/Rcs/getRegisteredRcsTemplates";
import { registerRcsTemplateMutation } from "api/Enterprise/Template/Rcs/registerRcsTemplate";
import { getRcsAssignedRoutesMutation } from "api/Enterprise/Routes/Rcs/getRcsAssignedRoutes";
import { getRcsOnboaredBSPMutation } from "api/SuperAdmin/Rcs/getRcsOnboardedBSP";
import { assignRcsRouteToEnterpriseMutation } from "api/SuperAdmin/Rcs/assignRcsRoute";

export const rcsServices = createApi({
  reducerPath: "rcsServices",

  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_RCS_API_PORT,
  }),

  endpoints: (builder) => ({
    ...registerRcsTemplateMutation(builder),
    ...getRegisteredRcsTemplatesMutation(builder),
    ...downloadRegisteredRcsTemplatesMutation(builder),
    ...deactivateRcsTemplatesMutation(builder),
    ...getRcsAssignedRoutesMutation(builder),
    ...getRcsOnboaredBSPMutation(builder),
    ...assignRcsRouteToEnterpriseMutation(builder)
  }),
});

export const {
  useRegisterRcsTemplateMutation,
  useGetRegisteredRcsTemplatesMutation,
  useDownloadRegisteredRcsTemplatesMutation,
  useDeactivateRcsTemplatesMutation,
  useAssignRcsRouteToEnterpriseMutation,
  useGetRcsAssignedRoutesMutation,
  useGetRcsOnboardedBSPMutation
} = rcsServices;
